import { Spin } from "antd";
import { useState } from "react";
import "../Reporting.scss";
import MessagePopUp from "../../../components/Messages/MessagePopUp";
import SubmittedForApproval from "./SubmittedForApproval";
import Approved from "./Approved";
import { useLocation } from "react-router-dom";

function ApproveSiteVisits() {
  const { search: view } = useLocation();
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  return (
    <Spin spinning={loading}>
      <div className="reportingListDiv">
        <div className="d-flex flex-column ">
          {view === "?SubmittedForApproval" ? (
            <SubmittedForApproval
              loading={loading}
              setLoading={setLoading}
              message={message}
              setMessage={setMessage}
            />
          ) : view === "?ApprovedVisits" ? (
            <Approved
              loading={loading}
              setLoading={setLoading}
              message={message}
              setMessage={setMessage}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
    </Spin>
  );
}

export default ApproveSiteVisits;
